import React, { useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
const TeamSection = () => {
  // Embla Carousel setup
  const teamMembers = [
    {
      image:
        "https://ik.imagekit.io/mileseducation/miles_website/about-us/Varun%20Jain.webp",
      name: "Varun Jain",
      role: "Founder & CEO",
      link: "https://www.linkedin.com/in/varunjain-cpa-cma-harvard-alumni/",
    },
    {
      image:
        "https://ik.imagekit.io/mileseducation/miles_website/about-us/Meenakshi%20Jain.webp",
      name: "Meenakshi Jain",
      role: "Co-founder & COO",
      link: "https://www.linkedin.com/in/meenakshi-jain-b60b248/",
    },
    {
      image:
        "https://ik.imagekit.io/mileseducation/miles_website/about-us/Harsh%20Jain.webp",
      name: "Harsh Jain",
      role: "Co-founder & Executive Director",
      link: "https://www.linkedin.com/in/harsh-jain-874a281b9/",
    },
    {
      image:
        "https://ik.imagekit.io/mileseducation/miles_website/about-us/Shivam%20Chopra.webp",
      name: "Shivam Chopra",
      role: "Co-founder & CTO",
      link: "https://www.linkedin.com/in/shivamchopra7/",
    },
    {
      image:
        "https://ik.imagekit.io/mileseducation/miles_website/about-us/Ashish%20Jalan.webp",
      name: "Ashish Jalan",
      role: " COO, Miles Talent Hub",
      link: "https://www.linkedin.com/in/ajadvisory/",
    },
    {
      image:
        "https://ik.imagekit.io/mileseducation/miles_website/about-us/Pratish%20Nair.webp",
      name: "Pratish Nair",
      role: "Founder & CEO, Miles SoBA",
      link: "https://www.linkedin.com/in/pratish-r-nair-45b51416/",
    },
    // {
    //   image: "/about-us/Priya.webp",
    //   name: "Priya Nair",
    //   role: " Co-founder & COO Miles SoBA",
    //   link: "https://www.linkedin.com/in/priya-menon-nair-5b7a84111/",
    // },
    {
      image:
        "https://ik.imagekit.io/mileseducation/miles_website/about-us/Rohini%20Sripada.webp",
      name: "Rohini Sripada",
      role: "Chief Business Officer",
      link: "https://www.linkedin.com/in/rohini-sripada-9312235/",
    },
    {
      image:
        "https://ik.imagekit.io/mileseducation/miles_website/about-us/Ravi%20T.webp",
      name: "Ravi T",
      role: "Chief Sales Officer",
      link: "https://www.linkedin.com/in/ravi-thiruvengalam-178923171/",
    },
  ];

  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    align: "start",
    dragFree: true,
    containScroll: "trimSnaps",
  });

  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    if (!emblaApi) return;
    const onSelect = () => {
      setSelectedIndex(emblaApi.selectedScrollSnap());
    };
    emblaApi.on("select", onSelect);
    onSelect();
    return () => {
      emblaApi.off("select", onSelect);
    };
  }, [emblaApi]);

  return (
    <>
      {/* Mobile Version */}
      <div className="w-full justify-center square_grid_bg md:hidden block py-4">
        <h2 className="text-[#000] text-center font-[Work Sans] text-[28px] font-semibold leading-[normal] tracking-[-1px] mx-auto mb-5">
          <span className="md:pb-0 inline-block border-[#ca7216] border-b-2">
            Meet The Founding Team
          </span>
        </h2>
        <div className="embla overflow-hidden h-[300px] pl-4" ref={emblaRef}>
          <div className="embla__container flex">
            {teamMembers.map((member, index) => (
              <div
                className="embla__slide flex-[0_0_auto] flex-shrink-0"
                style={{ minWidth: "190px", marginRight: "10px" }}
                key={index}
              >
                <div className="relative bg-white w-[190px] h-[265px] rounded-[20px] shadow-md overflow-hidden">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="object-cover w-full h-full rounded-[24px]"
                  />
                  <a
                    href={member.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="absolute top-3 right-3 z-20"
                  >
                    <img
                      src="/about-us/link.png"
                      alt="LinkedIn"
                      className="w-[28px] h-[28px]"
                    />
                  </a>
                  <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-60 rounded-[16px]"></div>
                  <div className="absolute bottom-4 left-4 text-white z-10">
                    <h3 className="text-[16px] font-semibold leading-[20.334px] tracking-[0.32px]">
                      {member.name}
                    </h3>
                    <p className="text-[14px] font-normal leading-[111%]">
                      {member.role}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="flex justify-center">
          {teamMembers.map((_, idx) => (
            <button
              key={idx}
              className={`w-2 h-2 rounded-full mx-1 transition-colors duration-200 ${selectedIndex === idx ? "bg-[#FFA548] opacity-100" : "bg-gray-400 opacity-75"}`}
              onClick={() => emblaApi && emblaApi.scrollTo(idx)}
              aria-label={`Go to slide ${idx + 1}`}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default TeamSection;
